import React from 'react';
import AboutPage from '../components/Groups/AboutPage/AboutPage';
import GroupChat from '../components/Groups/GroupChat/GroupChat';

import GroupJoinForm from '../components/Groups/Join/GroupJoinForm/GroupJoinForm';
import ManageMembers from '../components/Groups/ManageMembers/ManageMembers';
import RulesPage from '../components/Groups/RulesPage/RulesPage';

import { groupActions } from '../components/Includes/GroupActionTypes';
import CommonCardShell from '../components/Layout/CommonCardShell/CommonCardShell';
import UserIconListDisplay from '../components/Users/UserIconListDisplay/UserIconListDisplay';
import PermissionWrapper from '../components/Wrappers/PermissionWrapper/PermissionWrapper';

import { GroupConsumer } from '../contexts/GroupContext';

export const routes = {
    groups: {
        paths: [
            {
                path: '/about',
                render: () => <AboutPage />,
            },
            {
                path: '/rules',
                render: () => <RulesPage />,
            },
            {
                path: '/join',
                render: () => (
                    <GroupConsumer>
                        {({ userRelation, group: { hash } }) => (
                            <PermissionWrapper
                                hasPermission={!userRelation.role}
                                redirectTo={`/groups/${hash}`}
                            >
                                <CommonCardShell>
                                    <GroupJoinForm />
                                </CommonCardShell>
                            </PermissionWrapper>
                        )}
                    </GroupConsumer>
                ),
            },
            {
                path: '/members',
                render: () => (
                    <GroupConsumer>
                        {({
                            hasPermission,
                            getMemberList,
                            getMemberListPagination,
                            memberResults,
                            group: { hash },
                        }) => (
                            <PermissionWrapper
                                hasPermission={hasPermission(
                                    groupActions.VIEW_CONTENTS
                                )}
                                redirectTo={`/groups/${hash}`}
                            >
                                <UserIconListDisplay
                                    displayOnCenterRail={true}
                                    getUserList={getMemberList}
                                    header="members"
                                    hint="A = Admin; M = Moderator"
                                    showVipBadge={false}
                                />
                            </PermissionWrapper>
                        )}
                    </GroupConsumer>
                ),
            },
            {
                path: '/manage',
                render: () => (
                    <GroupConsumer>
                        {({ hasPermission, group: { hash } }) => (
                            <PermissionWrapper
                                hasPermission={hasPermission(
                                    groupActions.MANAGE_MEMBERS
                                )}
                                redirectTo={`/groups/${hash}`}
                            >
                                <ManageMembers />
                            </PermissionWrapper>
                        )}
                    </GroupConsumer>
                ),
            },
            {
                path: '/group-chat',
                render: () => (
                    <GroupConsumer>
                        {({ group, hasPermission }) => {
                            const { hash, headerImage } = group;
                            return (
                                <PermissionWrapper
                                    hasPermission={hasPermission(
                                        groupActions.GROUP_CHAT
                                    )}
                                    redirectTo={`/groups/${hash}`}
                                >
                                    <GroupChat
                                        channelKey={`group-chat-room-${hash}`}
                                        headerImage={headerImage}
                                        isAdmin={hasPermission(
                                            groupActions.EDIT_GROUP
                                        )}
                                    />
                                </PermissionWrapper>
                            );
                        }}
                    </GroupConsumer>
                ),
            },
        ],
        baseUrls: ['/groups/:groupHash', '/groups/:groupHash/:groupSlug'],
    },
};
